const config = {
    apiName: 'eventsapi',
    labelsApiName: 'labelsapi',
    basePath: '/'
};

export default config;